import { parseFields } from "../../schemaParser.js";
import { isArrayField, isObjectField } from "../../typeGuards.js";
import { validateCheckboxLists } from "./checkboxLists.js";
import { validateDependentFields } from "./dependent.js";
export * from "./dependent.js";
const validators = [validateDependentFields, validateCheckboxLists];
/**
 * Validates the form data against the schema.
 *
 * @template S The schema the form is being validated against.
 * @param data The form data to validate.
 * @param schema The schema to validate against.
 * @returns The validation result.
 * @throws Error An error if the schema doesn't have a shape defined.
 */
export function validateEntry(data, schema) {
    if (!("shape" in schema)) {
        throw new Error("Schema must have a shape.");
    }
    const removedEmptyFields = removeEmptyConstrainedFields(data, schema);
    const refined = schema.superRefine((fields, refinementContext) => {
        let newRefinementContext = refinementContext;
        for (const validator of validators) {
            newRefinementContext = validator(fields, newRefinementContext, schema.shape);
        }
        return newRefinementContext;
    });
    return refined.safeParse(removedEmptyFields);
}
/**
 * Unset any fields that have constraints but are optional and didn't receive
 * values.
 *
 * @param data The form data to adjust.
 * @param schema The schema to adjust the form data against.
 * @returns The adjusted form data.
 * @throws Error If the schema doesn't have a shape or is not an array.
 */
export function removeEmptyConstrainedFields(data, schema) {
    if (!("shape" in schema) && !Array.isArray(schema)) {
        throw new Error("Schema must have a shape or be a ParseField array.");
    }
    const fields = Array.isArray(schema)
        ? schema
        : parseFields(schema.shape, null);
    const adjustedState = { ...data };
    for (const field of fields) {
        if (isObjectField(field)) {
            data[field.field] = removeEmptyConstrainedFields(data[field.field], field.children);
        }
        else if (isArrayField(field)) {
            // TODO: Check for fields nested in arrays
        }
        else if (field.definition.checks?.length) {
            const value = data[field.field];
            if (!value) {
                delete adjustedState[field.field];
            }
        }
    }
    return adjustedState;
}
//# sourceMappingURL=index.js.map